import { render, staticRenderFns } from "./ContractWizard.vue?vue&type=template&id=2c60a538&scoped=true&"
import script from "./ContractWizard.vue?vue&type=script&lang=js&"
export * from "./ContractWizard.vue?vue&type=script&lang=js&"
import style0 from "./ContractWizard.vue?vue&type=style&index=0&id=2c60a538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60a538",
  null
  
)

export default component.exports